// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import myAccountFilterSectionStyles from "@flip/App/SharedStyle/MyAccount/List/MyAccountFilterSectionStyles";
import { xScreen } from "@flip/XDL/Utilities";
import translate from "@insite/client-framework/Translate";
import { savedOrderListFilterStyles } from "@insite/content-library/Widgets/SavedOrderList/SavedOrderListFilter";
import { css } from "styled-components";

savedOrderListFilterStyles.container = {
    ...myAccountFilterSectionStyles.searchFormStyles.wrapper,
};

savedOrderListFilterStyles.heading = {
    ...myAccountFilterSectionStyles.searchFormStyles.headingText,
};

savedOrderListFilterStyles.orderTotalGridItem = {
    css: css`
        padding: 15px 5px 15px 25px;

        ${xScreen("lte", "sm")} {
            padding: 15px 25px;
        }
    `,
    width: [12, 12, 6, 6, 6],
};

savedOrderListFilterStyles.datesGridItem = {
    width: [12, 12, 6, 4, 4],
    css: css`
        padding: 15px 30px;
    `,
};

savedOrderListFilterStyles.dateRangeFieldset = {
    css: css`
        border: none;
        margin: 0;
        padding: 0;
        width: 100%;

        ${xScreen("lte", "sm")} {
            padding: 0 10px;
        }
    `,
};

savedOrderListFilterStyles.orderTotalAmountTextField = {
    cssOverrides: {
        formInputWrapper: css`
            margin-top: 21px;
        `,
    },
    mergeCss: true,
    label: translate("Amount"),
} as any;

savedOrderListFilterStyles.datesGridItem = {
    width: [12, 12, 6, 6, 6],
};

savedOrderListFilterStyles.datesContainer = {
    css: css`
        width: 100%;
        ${xScreen("lte", "xs")} {
            flex-direction: column;
            > div {
                width: auto;
            }
        }
    `,
    offsetCss: css`
        display: flex;
        &&& {
            flex-wrap: nowrap;
        }
        > div {
            width: 50%;
            &:last-child {
                padding: 15px 25px 0 0;
                label {
                    visibility: hidden;
                }
            }
        }
        ${xScreen("lte", "sm")} {
            > div:last-child {
                padding: 15px 15px 0 5px;
            }

            > div:first-child {
                padding-right: 5px;
            }
        }
        ${xScreen("lte", "xs")} {
            flex-direction: column;
            > div {
                width: 100%;
                &:last-child {
                    padding: 0 15px 15px;
                }
                &:first-child {
                    padding-right: 15px;
                }
            }
        }
    `,
};

savedOrderListFilterStyles.orderTotalContainer = {
    gap: 15,
};

savedOrderListFilterStyles.orderTotalOperatorGridItem = {
    width: [12, 6, 6, 6, 6],
};

savedOrderListFilterStyles.orderTotalAmountGridItem = {
    width: [12, 6, 6, 6, 6],
};

savedOrderListFilterStyles.fromGridItem = {
    width: 12,
    css: css`
        > div {
            display: flex;
            width: 100%;

            ${xScreen("lte", "sm")} {
                padding-right: 5px;
            }

            ${xScreen("lte", "xs")} {
                padding-right: 0;
            }
        }
    `,
};

savedOrderListFilterStyles.toGridItem = {
    width: 12,
    css: css`
        > div {
            display: flex;
            width: 100%;
        }
    `,
};
